export const TEST_ID = 'goodStatusBadge';
